import { useStateMachine } from "#/components/context/stateMachine/StateMachineContext"
import { Steps } from "#/components/cmd-enrollment/workflow/steps"
import React, { useEffect } from "react"
import { IlloUnderwaterPlants } from "../../../views/atoms/Illustrations"
import { BenefitEnrollmentModalContinueButton } from "../../shared"
import { FormattedMessage } from "react-intl"
import { Box, Typography } from "@carrotfertility/carotene-core"
import { useProgressTracker } from "../../../views/modal/ProgressTracker"

export function SkipMemberConnectInsurance(): JSX.Element {
  const { setNextStep } = useStateMachine(Steps.SKIP_MEMBER_CONNECT_INSURANCE, null)

  const { showProgress } = useProgressTracker()
  useEffect(showProgress, [showProgress])

  function onClickContinue(): void {
    setNextStep(Steps.SKIP_MEMBER_CONNECT_INSURANCE, "")
  }

  return (
    <div>
      <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.xxxl })}>
        <Box display="flex" justifyContent="center" marginBottom="2.25rem">
          <IlloUnderwaterPlants />
        </Box>
      </Box>
      <Typography
        id="step-heading"
        variant="h2"
        color={(theme) => theme.palette.text.primary}
        paddingBottom={(theme) => theme.tokens.spacing.xs}
      >
        <FormattedMessage defaultMessage="You've skipped connecting to your insurance provider" />
      </Typography>
      <Box marginBottom={(theme) => theme.spacing(theme.tokens.spacing.xxxl)}>
        <Typography color={(theme) => theme.palette.text.secondary}>
          <FormattedMessage defaultMessage="We'll take it from here and will let you know if we have any more questions about your insurance." />
        </Typography>
      </Box>
      <BenefitEnrollmentModalContinueButton onClick={onClickContinue} />
    </div>
  )
}
